import axios from "axios";

export default {
  namespaced: true,
  state: {
    torneosData: null
  },
  mutations: {
    setTorneosData(state, data) {
      state.torneosData = data;
    }
  },
  actions: {
    async fetchTorneosData({ state, commit }) {
      if (state.torneosData) return state.torneosData;
      const response = await axios.get("/api/tournaments");

      commit("setTorneosData", response.data);
      return response.data;
    }
  }
}